export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Light.5ff3b407.ttf";